module.exports = __webpack_public_path__ + "static/media/alana.067d0602.png";